export const ThemeStoa = {
  Title: null
}
